/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { BACKEND_URL } from "src/constants";

// Every scrap-eye playlist hook (live/historical × angle/camera/radio) builds
// the same URL shape: BACKEND_URL with any trailing slash trimmed, the path
// resolved against the page origin, and string search params appended. Keeping
// it here stops the six call sites from drifting apart.
export const buildPlaylistUrl = (
  path: string,
  params: Record<string, string>
): string => {
  const base = BACKEND_URL?.endsWith("/")
    ? BACKEND_URL.slice(0, -1)
    : BACKEND_URL;
  const url = new URL(`${base}${path}`, window.location.origin);
  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, value);
  }
  return url.toString();
};
